import styled from 'styled-components';

export const LastCellContent = styled.div`
  padding: 13px 0;
  display: flex;
  justify-content: flex-end;

  svg {
    padding: 6px;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    cursor: pointer;

    :hover {
      background: var(--color-danger);
      color: var(--color-fixed-white);
    }
  }
`;
